function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "avatar-0-a",
  width: 100,
  height: 100,
  rx: 34
}), React.createElement("linearGradient", {
  id: "avatar-0-c",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#E6864E"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#EB965E"
})), React.createElement("linearGradient", {
  id: "avatar-0-d",
  x1: "81.058%",
  x2: "46.418%",
  y1: "33.5%",
  y2: "81.165%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#E07A3F"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#EB9154"
})), React.createElement("linearGradient", {
  id: "avatar-0-e",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#1D0024"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#100014"
})), React.createElement("linearGradient", {
  id: "avatar-0-f",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#1D0024"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#100014"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("mask", {
  id: "avatar-0-b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#avatar-0-a"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("use", {
  fill: "#A0A6B8",
  opacity: 0.1,
  xlinkHref: "#avatar-0-a"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 10h90v90H5z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#avatar-0-c)",
  d: "M47.872 46.195v3.885c0 3.453 2.423 5.935 7.27 7.445C49.559 61.842 43.868 64 38.073 64 32.275 64 26.584 61.842 21 57.525c4.885-1.51 7.31-3.992 7.271-7.445-.057-5.18-.019-8.222-.057-17.097-4.53-6.014-4.24-10.05-1.763-12.889 5.534-6.34 15.836-8.43 30.905-6.272 1.406 15.538.51 25.573-2.687 30.107-1.37 1.942-3.636 2.698-6.797 2.266z",
  transform: "translate(12 12)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#avatar-0-e)",
  fillRule: "nonzero",
  d: "M71.25 67.153C73.26 71.356 74.843 78.305 76 88H0c1.157-9.696 2.74-16.645 4.75-20.847 2.01-4.203 8.88-8.253 20.615-12.15 3.392 7.165 22.01 7.164 25.26-.003 11.74 3.898 18.615 7.95 20.625 12.153z",
  transform: "translate(12 12)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M50.5 80.5c-.828 0-1.5-.56-1.5-1.25S49.672 78 50.5 78s1.5.56 1.5 1.25-.672 1.25-1.5 1.25zm0 6.25c-.828 0-1.5-.56-1.5-1.25s.672-1.25 1.5-1.25 1.5.56 1.5 1.25-.672 1.25-1.5 1.25zm0 6.25c-.828 0-1.5-.56-1.5-1.25s.672-1.25 1.5-1.25 1.5.56 1.5 1.25S51.328 93 50.5 93z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#avatar-0-f)",
  fillRule: "nonzero",
  d: "M32.015 23.792c-1.005-.887-2.227-1.485-3.955-.563-4.095 2.187-.996 10.57 2.641 10.57.95 0 1.421 3.062-2.803 5.201 0-3.412-5.06-11.862-5.502-19.555-5.093-1.949-3.828-9.744-.33-9.744-.56-7.147 10.575-10.837 14.887-6.737 4.385-5.4 15.454-2.638 16.123 2.047 7.61-4.176 12.614 7.827 5.487 12.485-2.932 1.917-9.793 2.647-19.695 2.647-1.495 0-2.333.382-1.915 2.281.81 3.681-1.07 6-4.938 1.368z",
  transform: "translate(12 12)"
});

var SvgAvatar1 = function SvgAvatar1(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), _ref2, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _ref3, _ref4, React.createElement("g", {
    mask: "url(#avatar-0-b)"
  }, _ref5, _ref6, React.createElement("path", {
    fill: "url(#avatar-0-d)",
    d: "M48 46c-4.61-.556-8.276-1.889-11-4 2.305 4.111 5.971 6.778 11 8v-4z",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(12 12)"
  }), _ref7, _ref8, _ref9)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAvatar1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar-1.d2f0a177.svg";
export { ForwardRef as ReactComponent };